import React from 'react';

const CustomModal = props => {
    const divStyle = {
        display: props.displayModal ? 'block' : 'none'
    };
    const closeButtonStyle = {
        display: props.showDefaultCloseButton ? 'block' : 'none'
    };
    function closeModal(e) {
        e.stopPropagation()        
    }
    return (
        <div
            className="custom-modal"
            onClick={closeModal}
            style={divStyle} >
            <div
                className="custom-modal-content"
                onClick={e => e.stopPropagation()} >
                {props.children}
                <span style={closeButtonStyle} 
                    className="custom-modal-close"
                    onClick={closeModal}>&times;
             </span>
            </div>
        </div>
    );
}
export default CustomModal;